<template>
  <section class="section about-showcase">
    <div class="container about-layout">
      <div class="about-copy">
        <div class="about-en">ABOUT US</div>
        <h2 style="margin-bottom: 12px">{{ headingText }}</h2>
        <h2>{{ headingText1 }}</h2>
<!--        <div class="about-line"></div>-->
        <p style="margin-top: 20px">{{ paragraphText }}</p>

        <div class="about-advantages">
          <article v-for="item in advantages" :key="$pick(item.title)" class="advantage-item" v-reveal>
            <strong>{{ $pick(item.title) }}</strong>
            <span>{{ $pick(item.text) }}</span>
          </article>
        </div>
      </div>

      <div class="about-visual" v-reveal>
        <div class="about-image-shell">
          <div class="about-image" :style="aboutImageStyle"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutShowcase",
  props: {
    stats: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      advantages: [
        {
          title: { "zh-CN": "卓越品质保障", "en-US": "Excellent Quality Assurance" },
          text: { "zh-CN": "严苛品控体系与精密检测设备，为产品稳定运行提供保障。", "en-US": "Strict quality control and precision testing support stable product performance." }
        },
        {
          title: { "zh-CN": "全品类供应支持", "en-US": "Full Category Supply Support" },
          text: { "zh-CN": "覆盖变压器、箱变、成套设备等全系列配电产品。", "en-US": "Covering transformers, substations, complete sets and related distribution equipment." }
        },
        {
          title: { "zh-CN": "高效贴心服务", "en-US": "Efficient and Attentive Service" },
          text: { "zh-CN": "提供方案设计、设备集成、安装调试等一站式服务。", "en-US": "Providing one-stop support from solution design to integration and commissioning." }
        }
      ]
    };
  },
  computed: {
    aboutImageStyle() {
      return {
        backgroundImage: "linear-gradient(180deg, rgba(255, 255, 255, 0.02), rgba(0, 0, 0, 0.08)), url('/about/about.jpg')",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
      };
    },
    headingText() {
      return this.locale === "zh-CN"
        ? "宏邦变压器全场景解决方案"
        : "Diversified transformer solutions delivering technical support for industrial power applications.";
    },
    headingText1() {
      return this.locale === "zh-CN"
        ? "为安全配电提供坚实保障"
        : "Provide a solid guarantee for safe power distribution.";
    },
    paragraphText() {
      return this.locale === "zh-CN"
        ? "江苏宏邦变压器有限公司坐落于江苏徐州工业园区，致力于为客户提供整体配电系统解决方案。公司聚焦工商业、新能源、市政电网、海外工程全场景配电需求，不仅提供高品质的电力变压器、干式/油浸式变压器、非晶合金变压器、隔离变压器，还配套生产高低压开关柜、箱式变电站（欧变/美变）、配电箱、电抗器、消弧线圈、矿用及船用特种变压器等全系列配电设备。同时可承接方案设计、设备集成、安装调试等一站式服务。公司拥有标准化生产基地、全套精密生产检测设备，组建了专业的配电电气设计团队与工程服务团队，具备完整的配电系统方案落地能力。依托成熟的技术积累与严苛的品控体系，可为不同行业、不同工况提供定制化、一体化、高适配的配电整体解决方案."
        : "Jiangsu Hongbang Transformer Co., Ltd., located in Xuzhou Industrial Park, Jiangsu Province, is committed to providing customers with comprehensive power distribution system solutions. The company focuses on the full-scenario power distribution needs of industrial and commercial sectors, new energy, municipal power grids, and overseas projects. It not only provides high-quality power transformers, dry-type/oil-immersed transformers, amorphous alloy transformers, and isolation transformers, but also manufactures a full range of power distribution equipment, including high and low voltage switchgear, prefabricated substations (European/American transformers), distribution boxes, reactors, arc suppression coils, and special transformers for mining and marine applications. The company also provides one-stop services such as solution design, equipment integration, installation, and commissioning. With a standardized production base, a full set of precision production and testing equipment, and a professional power distribution design and engineering service team, the company possesses complete capabilities for implementing power distribution system solutions. Relying on mature technological accumulation and a rigorous quality control system, it can provide customized, integrated, and highly adaptable overall power distribution solutions for different industries and operating conditions.";
    }
  }
};
</script>

<style scoped>
.about-showcase {
  background: #ffffff;
}

.about-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(420px, 0.9fr);
  gap: 50px;
  align-items: start;
}

.about-en {
  margin-bottom: 16px;
  font-size: clamp(48px, 6vw, 78px);
  font-weight: 800;
  line-height: 0.95;
  background: linear-gradient(90deg, #0f57a8 0%, #1a6fcb 50%, #4f64b8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.about-copy h2 {
  margin: 0;
  color: #262626;
  font-size: clamp(34px, 5vw, 38px);
  line-height: 1.24;
  font-weight: 500;
}

.about-line {
  width: 92px;
  height: 2px;
  margin: 28px 0 34px;
  background: linear-gradient(90deg, #1a4e93, #1a6fcb);
}

.about-copy p {
  margin: 0;
  color: #4d5562;
  font-size: 16px;
  line-height: 2;
}

.about-advantages {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-top: 56px;
}

.advantage-item {
  padding: 24px 22px;
  border-top: 3px solid var(--brand-blue);
  background: #f7f9fc;
  box-shadow: 0 14px 34px rgba(18, 54, 110, 0.08);
}

.advantage-item strong {
  display: block;
  color: #202020;
  font-size: 22px;
  line-height: 1.35;
}

.advantage-item span {
  display: block;
  margin-top: 12px;
  color: #383d46;
  font-size: 14px;
  line-height: 1.8;
}

.about-visual {
  display: flex;
  justify-content: flex-end;
}

.about-image-shell {
  width: min(100%, 780px);
  border-radius: 40px 0 0 40px;
  overflow: hidden;
  box-shadow: 0 26px 56px rgba(18, 54, 110, 0.12);
}

.about-image {
  min-height: 920px;
  background-size: cover;
}

@media (max-width: 1200px) {
  .about-layout {
    grid-template-columns: 1fr;
  }

  .about-copy h2 {
    max-width: none;
  }

  .about-image {
    min-height: 520px;
  }
}

@media (max-width: 900px) {
  .about-advantages {
    grid-template-columns: 1fr;
    gap: 22px 16px;
    margin-top: 36px;
  }

  .about-image-shell {
    border-radius: 24px;
  }

  .about-image {
    min-height: 360px;
  }
}

@media (max-width: 520px) {
  .about-layout {
    gap: 32px;
  }

  .about-en {
    font-size: 42px;
  }

  .about-copy h2 {
    font-size: 26px;
  }

  .about-copy p {
    font-size: 14px;
    line-height: 1.85;
  }

  .advantage-item {
    padding: 20px 18px;
  }

  .about-image {
    min-height: 260px;
  }
}
</style>
